@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/spacers';

.questionnaire {
  writing-mode: vertical-lr;
  box-shadow: inset 0 0 0 1px #2d0e50;
  text-align: center;
  font-weight: 500;
  font-size: 1rem;
  width: 38px;
  line-height: 38px;
  padding: 1rem 0;
  color: black;
  position: fixed;
  top: 75vh;
  right: 0;
  border-radius: 6px 0 0 6px;
  font-family: Avenir, Montserrat, Poppins, serif;
  text-decoration: none;
  border: none;
  background: #80b2ce;

  &:focus,
  &:hover {
    background: #43779c;
    color: #fff;
    outline: none;
  }

  &:focus {
    box-shadow: inset 0 0 0 1px #fff;
  }

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: map.get($grid-breakpoints, md)) {
    top: 65vh;
  }
}
